export const IS_DEMO = Boolean(process.env.DEMO);
export const IS_DZD = window.location.host.includes('dzd');
export const IS_SOLIDSUN = window.location.host.includes('solidsun');

import { AppUiVariant } from '../../core/src/shared/enums';
import { Variables } from './store/types';

export const APP_UI_VARIANT =
  window.__APP_CONFIG__.APP_UI_VARIANT ??
  (IS_SOLIDSUN ? AppUiVariant.Solidsun : AppUiVariant.Default);

type AppConfig = Pick<Variables, 'APP_UI_VARIANT'>;

declare global {
  interface Window {
    __APP_CONFIG__: AppConfig;
  }
}
